export const URL_REGEX = /((https?):\/\/)?.\.(com|tv)/;
export const TWITCH_REGEX = /^((https?):\/\/)?(www\.)?(twitch\.)(com|tv)\/./;
export const YOUTUBE_REGEX =
  /^((https?):\/\/)?(www\.)?((youtube\.com\/((watch\?)|(embed\/.)))|(youtu\.be\/.)){1}/;
